import { useEffect, useState } from "react";
import { fetchHealth } from "@/repositories/sheetPreviewRepository";

interface HealthResult {
  status: string;
  googleSheetsConnected?: boolean;
  error?: string;
  hint?: string;
  missingSecrets?: string[];
  spreadsheetId?: string;
  latencyMs?: number;
  writeEnabled?: boolean;
}

export function SystemStatusPage() {
  const [health, setHealth] = useState<HealthResult | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHealth()
      .then((h) => setHealth(h as HealthResult))
      .catch((e) => setHealth({ status: "error", error: String(e) }))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ maxWidth: 640, margin: "60px auto", padding: 24, fontFamily: "sans-serif", color: "#eee" }}>
      <h1>AlifBee — System Status</h1>
      <p style={{ color: "#999" }}>
        This page checks whether the deployed site can talk to Google Sheets with the
        Service Account credentials configured in Cloudflare. Open this page any time
        after deployment to verify the connection — no technical knowledge needed.
      </p>

      {loading && <p>Checking connection…</p>}

      {health && (
        <div style={{ marginTop: 20, padding: 16, borderRadius: 10, background: "#1c1f26", border: "1px solid #2e323d" }}>
          {health.status === "ok" && (
            <>
              <p style={{ color: "#34d399", fontWeight: 600 }}>✅ Connected to Google Sheets</p>
              <p>Spreadsheet ID: <code>{health.spreadsheetId}</code></p>
              <p>Response time: {health.latencyMs} ms</p>
              <p>Write access enabled: {health.writeEnabled ? "Yes" : "No (read-only, as expected)"}</p>
            </>
          )}
          {health.status === "not_configured" && (
            <>
              <p style={{ color: "#fbbf24", fontWeight: 600 }}>⚠️ Not configured yet</p>
              <p>Missing secrets: {health.missingSecrets?.join(", ")}</p>
              <p style={{ color: "#999" }}>{health.hint}</p>
            </>
          )}
          {health.status === "error" && (
            <>
              <p style={{ color: "#f87171", fontWeight: 600 }}>❌ Connection failed</p>
              <p style={{ color: "#999" }}>{health.error}</p>
              {health.hint && <p style={{ color: "#999" }}>{health.hint}</p>}
            </>
          )}
        </div>
      )}
    </div>
  );
}
